import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { setPopup } from "../../../actions/popupAction";
import { SMSIconLarge, EmailIconLarge } from "../../../assets/svg";
import UserService from "../../../service/UserService";
import CustomButton from "../../customButton";

import "./styles.scss";

const MFA = ({ onBack, phoneNumber, email, otpState, history, otpToken }) => {
  const dispatch = useDispatch();
  const submitRef = useRef(false);

  const userService = new UserService();

  const onSelect = async (target) => {
    try {
      if (submitRef.current) return;
      submitRef.current = true;

      const isSMS = target === "phone";
      const userData = await userService.sendOtp(otpToken, target);

      if (userData.data.success === true) {
        const {
          data: { otpAttempts, otpTokenExpiresIn = 1, token },
        } = userData;

        // update cookie
        userService.setToken(token, otpTokenExpiresIn * 60);
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "success",
            message: `OTP has been sent successfully to the registered ${
              isSMS ? "mobile number" : "email address"
            }`,
          })
        );

        history.push({
          pathname: "/otp",
          state: {
            ...otpState,
            target,
            data: (isSMS ? phoneNumber : email).replace(/([xX]+)/, "xxx"),
            otpAttempts: +otpAttempts,
            isSMS,
            otpTokenExpiresIn,
          },
        });
      }
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: err?.response?.data?.message || "Something went wrong",
        })
      );
    }

    submitRef.current = false;
  };

  return (
    <div className="mfa-outer-container">
      <h2 className="form-heading">Verify Your Identity</h2>
      <div className="mfa-container">
        <div className="mfa-item" onClick={() => onSelect("phone")}>
          <SMSIconLarge />
          <div className="mfa-text">SMS {phoneNumber}</div>
        </div>
        <div className="mfa-item" onClick={() => onSelect("email")}>
          <EmailIconLarge />
          <div className="mfa-text">Email {email}</div>
        </div>
      </div>

      <CustomButton
        type="primary"
        className="cancel-button"
        onClick={onBack}
        title="Go Back"
      />
    </div>
  );
};

export default MFA;
